// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610022001/js/" + chunkId + "." + {"44":"e95235ff","225":"ca4ac575","481":"f49a3d13","486":"76ffb75b","770":"fc8c8c82"}[chunkId] + ".0.7397181669914753.chunk.js";
};